
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"18","viewBox":"0 0 14 18","fill":"#E4340D","stroke":"#E4340D","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 1C5 0.447715 5.44772 0 6 0H8C8.55228 0 9 0.447715 9 1V2H5V1Z","stroke":"none"}}),_c('path',{attrs:{"d":"M0 3C0 2.44772 0.447715 2 1 2H13C13.5523 2 14 2.44772 14 3V4H0V3Z","stroke":"none"}}),_c('path',{attrs:{"d":"M2 3V16C2 16.5523 2.44772 17 3 17H11C11.5523 17 12 16.5523 12 16V3","fill":"none","stroke-width":"2"}})])
          )
        }
      }
    